import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "User",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "service_name_slug",
    render: defaultRender,
  },
  {
    title: "File No.",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Start Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value)=>(<StatusBadge status={value}/>),
  },
];

export default columns;
